import PrimaryButton from '@/components/Buttons/PrimaryButton';
import GlassCard from '@/components/GlassCard';
import PageTitle from '@/components/PageTitle';
import ThemeWrapper from '@/components/ThemeWrapper';
import AppLayout from '@/layouts/AppLayout';
import { Evaluation } from '@/types';
import { router } from '@inertiajs/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface TimeUpProps {
    evaluation: Evaluation;
    course: {
        slug: string;
    };
}

const TimeUpContent: React.FC<TimeUpProps> = ({ evaluation, course }) => {
    const { t } = useTranslation();

    const handleReturnToCourse = () => {
        router.get(`/courses/${course.slug}/`);
    };

    const handleViewResults = () => {
        router.get(`/evaluations/${evaluation.id}/results/`);
    };

    return (
        <AppLayout>
            <PageTitle title="Tiempo Agotado" />
            <div className="min-h-screen flex items-center justify-center px-4 py-8">
                <GlassCard className="max-w-md w-full overflow-hidden">
                    {/* Header */}
                    <div className="bg-red-500 px-8 py-6">
                        <div className="text-center">
                            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-white flex items-center justify-center">
                                <svg className="w-8 h-8 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                </svg>
                            </div>
                            <h1 className="text-2xl font-bold text-white mb-2">
                                {t('evaluation.timeUp.title')}
                            </h1>
                            <p className="text-red-100">
                                {evaluation.title}
                            </p>
                        </div>
                    </div>

                    {/* Content */}
                    <div className="px-8 py-6">
                        <div className="text-center mb-6">
                            <p className="text-gray-600 dark:text-neutral-300 mb-4">
                                {t('evaluation.timeUp.message')}
                            </p>
                            <p className="text-sm text-gray-500 dark:text-neutral-400">
                                {t('evaluation.timeUp.autoSubmitted')}
                            </p>
                        </div>

                        {/* Action Buttons */}
                        <div className="space-y-3">
                            <PrimaryButton onClick={handleViewResults} size="md" className="w-full">
                                {t('evaluation.timeUp.viewResults')}
                            </PrimaryButton>
                            
                            <button
                                onClick={handleReturnToCourse}
                                className="w-full px-4 py-2 text-sm font-medium text-gray-700 dark:text-neutral-200 bg-gray-100 dark:bg-neutral-700 hover:bg-gray-200 dark:hover:bg-neutral-600 rounded-md transition-colors duration-200"
                            >
                                {t('evaluation.timeUp.returnToCourse')}
                            </button>
                        </div>
                    </div>
                </GlassCard>
            </div>
        </AppLayout>
    );
};

const TimeUp: React.FC<TimeUpProps> = (props) => {
    return (
        <ThemeWrapper>
            <TimeUpContent {...props} />
        </ThemeWrapper>
    );
};

export default TimeUp;